import React from 'react';
import PropTypes from 'prop-types';
import { Button, Modal } from 'react-bootstrap';
import ButtonWithLoader from 'components/ButtonWithLoader/ButtonWithLoader';
import styles from './BulkConfirmationModal.module.scss';

const BulkConfirmationModal = ({
  show,
  onHide,
  onConfirm,
  title,
  message,
  confirmText,
  confirmStyle,
  loading,
}) => {
  return (
    <Modal show={show} onHide={onHide} dialogClassName={styles.modal}>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className={styles.message}>{message}</p>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={onHide} className={styles.button} disabled={loading}>
          Cancel
        </Button>
        <ButtonWithLoader
          bsStyle={confirmStyle || 'primary'}
          onClick={onConfirm}
          disabled={loading}
          loading={loading}
          className={styles.button}
          text={loading ? 'Processing...' : confirmText}
        />
      </Modal.Footer>
    </Modal>
  );
};

BulkConfirmationModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  confirmText: PropTypes.string.isRequired,
  confirmStyle: PropTypes.string,
  loading: PropTypes.bool,
};

export default BulkConfirmationModal;
